import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'multipleVideos',
    standalone: true
})
export class MultipleVideosPipe implements PipeTransform {
    transform(source?: string): string[] {
        if (!source) {
            return [];
        }

        return source?.split(',');
    }
}
